<template>
  <div class="main">
<!--		<div class="ser-form">-->
<!--			<Button type="primary" @click="sendSms">发送短信</Button>-->
<!--		</div>-->
		<div class="table-list">
			<Table :data="data" :loading="loading" :columns="columns"></Table>
		</div>
		<div class="ser-page">
			<Page class-name="page-r" :total="total" :page-size="searchForm.limit" :page-size-opts="[15,30,50]" show-total show-sizer @on-change="set_current" @on-page-size-change="set_per"></Page>
		</div>
  </div>
</template>

<script>
    export default {
        name: "SmsLog",
		data() {
			return {
				loading: false,
				searchForm: {
					page: 1,
					limit: 15,
				},
				columns: [
					{title: 'ID', key: 'id', width: 80},
					{title: '手机号', key: 'phone', width: 150},
					{title: '签名内容', key: 'template_name', width: 150},
					{title: '发送内容', key: 'send_content', minWidth: 230},
					{title: '发送状态', key: 'status', width: 120,align:'center',render:(h,params)=>{
						return h('Tag',{
							props:{
								color:params.row.status?'success':'error'
							}
						},this.status_array[params.row.status])
						}},
					{title: '发送时间', key: 'create_time', width: 160}
				],
				status_array:['失败','成功'],
				data:[],
				total: 0,
			}
		},
		created() {
			this.loading = true;
			this.init()
		},
		methods: {
			init() {
				var _this = this;
				this.requestApi('/adm/get_send_list',{data:this.searchForm}).then((res) => {
						_this.loading = false;
						_this.data = res.data.data;
						_this.total = res.data.total;
					})
			},
			sendSms(){
				var _this = this;
				this.requestApi('/adm/send_sms_sign',{}).then(function (res) {
					if(res.status){
						_this.alertSucc(res.msg);
					}else{
						_this.alertErr(res.msg);
						_this.alertErr(res.message);
					}
				})
			},
			//切换页数
			set_current(page) {
				this.searchForm.page = page;
				this.init()
			},
			//切换条数
			set_per(limit) {
				this.searchForm.page =1;
				this.searchForm.limit = limit;
				this.init()
			}
		}
    }
</script>

<style scoped>
	.main {
		background: #fff;
	}
	.ser-form{
		padding: 12px;
	}
	.page-r {
		margin-top: 10px;
		text-align: right;
	}
	.ser-page{
		padding-bottom: 12px;
	}
</style>
